<ng-template [bgAwaitPromises]="badgeIdParam">
	<!-- Embedded View -->
	<div class="l-cardembedded" *ngIf="embedService.isEmbedded">
		<div class="card card-largeimage">
			<a class="card-x-main" [href]="badgeClass.id" target="_blank">
				<div class="card-x-image">
					<img [loaded-src]="badgeClass.image"
					     [loading-src]="badgeLoadingImageUrl"
					     [error-src]="badgeFailedImageUrl"
					     width="60" height="60" />
				</div>
				<div class="card-x-text">
					<h1>{{ badgeClass.name }}</h1>
					<small>{{ issuer.name }}</small>
					<p [truncatedText]="badgeClass.description" [maxLength]="100"></p>
				</div>
			</a>
		</div>
	</div>

	<!-- Regular View -->
	<main class="o-container"
		*ngIf="! embedService.isEmbedded">
		<form-message></form-message>
		<div class="badgedetail">
			<div class="badgedetail-x-header">

				<!-- Badge Name -->
				<h1>{{ badgeClass.name }}</h1>

				<!--
				<div class="l-primarymore">
				-->

					<!-- URLs -->
					<!--
					<section>
						<a [href]="v1JsonUrl"
						   class="button button-primaryghost"
						>v1 JSON</a>
						<a [href]="v2JsonUrl"
						   class="button button-primaryghost"
						>v2.0 JSON</a>
						<a [href]="badgeClass.sourceUrl"
						   *ngIf="badgeClass.sourceUrl"
						   class="button button-primaryghost"
						>View Original</a>
					</section>
					-->
				<!--
				</div>
				-->
			</div>
			<div class="badgedetail-x-sidebar">
				<div class="badgedetail-x-sidebarinternal">

					<!-- Badge Assertion Image -->
					<img alt="{{badgeClass.name}} image"
						 class="badgeimage badgeimage-center badgeimage-large"
						 [loaded-src]="badgeClass.image"
					     [loading-src]="badgeLoadingImageUrl"
					     [error-src]="badgeFailedImageUrl"
					     width="200" />
					<!-- Issuer Information -->
					<dl>
				    	<div class="l-flex l-flex-2x u-padding-top2x border border-top border-light3">
							<div>
								<img [loaded-src]="issuer.image"
									 [loading-src]="issuerImagePlacholderUrl"
									 [error-src]="issuerImagePlacholderUrl"
									 width="100" />
							</div><div>
								<dt class="u-text-small-bold">{{ 'earnedBadgeAndBadgeDetailPage.issuedBy' | translate }}:</dt>
								<dd class="u-text">
	                				<a class="u-break-word"
	                					[routerLink]="routerLinkForUrl(issuer.hostedUrl || issuer.id)"
	                				>{{ issuer.name }}</a>
	            				</dd>
								<img alt="Verified Issuer" class="emptysection-x-image  u-margin-top1x verified-logo"
								[src]="verifiedSrc" [bgPopupMenuTrigger]="issuerVerified">
								<bg-popup-menu #issuerVerified class="menu l-flex l-flex-column l-flex-2x menu-is-open verified-popup">
									<div class="l-grid l-grid-1 l-grid-1x" style="--cols: 1fr auto; align-items: stretch;">
										<div>
											<div class="l-flex l-flex-5x l-flex-justifybetween u-margin-bottom1x">
												<h2 class="u-text u-text-h3 u-text-dark3"> {{ 'earnedBadgeAndBadgeDetailPage.verifiedIssuer' | translate }} </h2>
												<img alt="Verified Issuer" class="emptysection-x-image verified-logo" [src]="verifiedSrc">
											</div>
										<ul class="u-text u-margin-bottom1x">
											<li>
												<strong class="u-text-dark3 u-text-bold">{{ 'earnedBadgeAndBadgeDetailPage.organization' | translate }}: </strong>
												<a class="u-text-link" style="font-size: inherit;" href="{{ issuer.id }}"> {{ issuer.name }} </a>
											</li>
											<li>
												<strong class="u-text-dark3 u-text-bold">{{ 'earnedBadgeAndBadgeDetailPage.issuer' | translate }}: {{ issuer.name }} </strong>
												<span class="u-text" style="font-size: inherit;">  </span>
											</li>
										</ul>
										<p class="u-text u-text-small"> {{ 'earnedBadgeAndBadgeDetailPage.thisIssuerIsPartOfAVerifiedOrganization' | translate }}.</p>
										</div>
									</div>
								</bg-popup-menu>
							</div>
						</div>
					</dl>
				</div>
			</div>
			<div class="badgedetail-x-desc">
				<h2 class="u-text-h3-semibold u-margin-bottom2x u-hidden-mintablet">{{ 'earnedBadgeAndBadgeDetailPage.description' | translate }}</h2>
				<p class="u-text-body u-width-paragraph">{{ badgeClass.description }}</p>
			</div>
			<div class="badgedetail-x-body">

				<!-- criteria -->
				<section *ngIf="badgeClass.criteria">
					<h3 class="u-text-h3-semibold u-text-dark2 u-margin-bottom2x u-margin-top4x"
						*ngIf="badgeClass.criteria.id || badgeClass.criteria.narrative"
						>{{ 'earnedBadgeAndBadgeDetailPage.criteria' | translate }}</h3>
					<show-more>
						<markdown-display
							 *ngIf="badgeClass.criteria.narrative"
							 [value]="badgeClass.criteria.narrative">
					 	</markdown-display>
					</show-more>
					<div class="u-margin-yaxis2x"
							*ngIf="badgeClass.criteria.id">
							<a class="u-text-outlink" target="_blank"
								[href]="badgeClass.criteria.id"
							>{{ 'earnedBadgeAndBadgeDetailPage.viewExternalCriteriaUrl' | translate }}
								<svg icon="icon_external_link"></svg>
							</a>
						</div>
				</section>

				<button
					*ngIf="badgeClass.tags && badgeClass.tags.length"
					class="button"
					type="button"
					(click)="jobInsights()"
				>
					{{ 'earnedBadgeAndBadgeDetailPage.jobInsights' | translate }}
				</button>	

				<!-- alignment -->
				<section>
					<h3 class="u-text-h3-semibold u-margin-bottom2x u-margin-top4x"
						*ngIf="badgeClass.alignment && badgeClass?.alignment.length>0"
					>{{ 'earnedBadgeAndBadgeDetailPage.alignment' | translate }}</h3>
					<div class="bordered l-padding-2x l-marginBottom-2x"
					     *ngFor="let alignmentNode of badgeClass.alignment; let i=index">
						<div class="l-flex l-flex-justifybetween">
							<h4 class="u-text-body-bold u-margin-bottom1x">{{ alignmentNode.targetName }}</h4>
							<small>{{ alignmentNode.targetCode }}</small>
						</div>
						<p class="u-break-word u-text-body u-width-paragraph"
							*ngIf="alignmentNode.targetDescription"
						>{{ alignmentNode.targetDescription }}</p>

						<div *ngIf="alignmentNode.frameworkName">
							<h4>{{ 'earnedBadgeAndBadgeDetailPage.framework' | translate }}</h4>
							{{ alignmentNode.frameworkName }}
						</div>
						<div class="u-margin-yaxis2x"
							 *ngIf="alignmentNode.targetUrl">
							<a class="u-text-outlink" target="_blank"
								[href]="alignmentNode.targetUrl"
							>{{ 'earnedBadgeAndBadgeDetailPage.viewAlignmentUrl' | translate }}
								<svg icon="icon_external_link"></svg>
							</a>
						</div>
					</div>
				</section>

				<!-- tags -->
				<section>
					<h3 class="u-text-h3-semibold u-margin-bottom2x u-margin-top4x"
						*ngIf="badgeClass.tags && badgeClass.tags.length">{{ 'earnedBadgeAndBadgeDetailPage.tags' | translate }}</h3>
					<div class="l-tags">
						<div class="tag"
							*ngFor="let tag of badgeClass.tags; last as last"
						>{{ tag }}</div>
					</div>
				</section>
			</div>
		</div>
	</main>
</ng-template>
